import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogConfig } from '../interfaces/mat.interface';


@Injectable({
  providedIn: 'root',
})
export class MatDialogService {
  private _dialog = inject(MatDialog);

  openMatDialog<T, D>(args: DialogConfig<T, D>): MatDialogRef<T> {
    return this._dialog.open(args.component, {
      data: args.data ?? null,
      panelClass: args.panelClass ?? '',
      enterAnimationDuration: args.enterAnimationDuration ?? '0ms',
      exitAnimationDuration: args.exitAnimationDuration ?? '150ms',
    });
  }

  closeMatDialog<T>(matDialogRef: MatDialogRef<T>): void {
    matDialogRef?.close();
  }

  closeAllMatDialogs(): void {
    this._dialog?.closeAll();
  }
}
